import { List } from 'immutable';

//=========================================================
//  CONSTANTS
//---------------------------------------------------------
export const APP_NAME = 'galeno-internacion-domiciliaria'
export const APP_BASE_URL = window.API_BASE_URL || 'https://galeno-cdom-api-qa.dcoworks.com'
export const APP_VERSION = '1.0.3'

//=====================================
//  API
//-------------------------------------
export const API_KEY = window.API_KEY || ''
export const API_BASE_URL =  window.API_BASE_URL || ''
export const API_BASE_URL_V =  `${API_BASE_URL}/api`;
export const DEFAULT_SESSION_ID = "session-galeno"


export const API_ORDENES_URL = `${API_BASE_URL_V}/ordenes`;

export const API_SYSTEM_URL = `${API_BASE_URL_V}/system`;

export const API_PRACTICAS_URL = `${API_BASE_URL_V}/practicas`;
export const API_PRESTADORES_URL = `${API_BASE_URL_V}/prestadores`;
export const API_EFECTORES_URL = `${API_BASE_URL_V}/efectores`;

export const API_ESPECIALIDADES_URL = `${API_SYSTEM_URL}/especialidades`;
export const API_LOCALIDADES_URL = `${API_SYSTEM_URL}/localidades`;
export const API_PROVINCIAS_URL = `${API_SYSTEM_URL}/provincias`;

export const API_NOTIFICACIONES_URL = `${API_BASE_URL_V}/notificaciones`;

export const API_REVERSE_GEO = 'https://nominatim.openstreetmap.org/reverse';

export const API_DOWNLOAD_ORDER = `${API_BASE_URL_V}/download/orden`;
export const API_DOWNLOAD_REPORTE = `${API_BASE_URL_V}/download/reporte/`;




// EFECTORES CONTROLLER

// GET /api/efectores ,
// GET /api/efectores/{id} ,
// GET /api/efectores/{dni} ,
// POST /api/efectores ,
// PUT /api/efectores,
// DELETE /api/efectores/{id}
export const API_EFECTORES_VISITAS_URL = `${API_EFECTORES_URL}/visitas`;

export const EFECTORES='/efectores';
// POST /api/efectores/login
export const POST_EFECTORES_LOGIN= `${API_EFECTORES_URL}/login`;


// GET /api/efectores/visitas/vigentes
export const GET_EFECTORES_VISITAS_VIGENTES='/efectores/visitas/vigentes';

// GET /api/efectores/visitas/cerradas
export const GET_EFECTORES_VISITAS_CERRADAS='/efectores/visitas/cerradas';

// GET /api/efectores/visitas/{id}
export const GET_EFECTORES_VISITAS='/efectores/visitas/';

// GET /api/efectores/visitas/{id}/registros
export const GET_EFECTORES_VISITAS_REGISTROS='/registros';

// POST /api/efectores/visitas/{id}/ingreso
export const POST_EFECTORES_VISITAS_INGRESO='/ingreso';


// POST /api/efectores/visitas/{id}/egreso
export const GET_EFECTORES_VISITAS_EGRESO='/egreso';

// GET /api/efectores/novedades
// GET /api/efectores/novedades/{id}
export const GET_EFECTORES_NOVEDADES=`${API_EFECTORES_URL}/novedades`;

export const USER_ID = window.user_id || null;
export const DEFAULT_PER_PAGE = window.default_pagesize || 10;

export const ORDERS_STATUS_LIST_OPTIONS = new List([
   { label: 'Recibida', id: 'R'},
   { label: 'Asignada', id: 'A'},
   { label: 'Parcialmente Asignada', id: 'PA'},
   { label: 'Dada de Baja', id: 'C'}
])

export const PRACTICE_FREQUENCY_LIST_OPTIONS = new List([
   { label: 'Semanal', id: 'sem'},
   { label: 'Diaria', id: 'dia'},
])

export const NOTIFICATIONS_EVENTS_LIST_OPTIONS = new List([
  { label: 'Alta de Orden', id:"alta-ord" },
  { label: 'Alta de Práctica', id:"alta-prc" },
  { label: 'Baja de Orden', id:"baja-ord" },
  { label: 'Baja de Práctica ', id:"baja-prc" },
  { label: 'Baja de Asociado', id:"baja-asc" },
  { label: 'Modificación de Paciente', id:"upd-pac" }
])
